import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface SortEventArgs {
  direction: string;
  name: string;
}

class SortEvent extends EventData<Sortable> {

  direction: string;
  name: string;

  constructor({ direction, name }: SortEventArgs) {
    super();
    this.name = name;
    this.direction = direction;
  }
}

class SortEventListener extends EventListener<Sortable, SortEvent, SortEventArgs> {
  constructor() {
    super(SortEvent);
  }
}

export default interface Sortable extends Mountable {

  /** @event */
  onSort: SortEventListener;

}

export { SortEventListener, SortEvent };
